// Media queries the scripts share: the desktop / phone split ("hp" in
// _breakpoints.scss — change both together) and a change listener that
// also works before Safari 14 (no MediaQueryList.addEventListener there).

export const DESKTOP = '(min-width: 1260px)';

/** Call handler(event) whenever query, a MediaQueryList, starts or stops matching. */
export function onMediaChange(query, handler) {
  if (typeof query.addEventListener === 'function') query.addEventListener('change', handler);
  else query.addListener(handler);
}
